import React, { useRef, useState, useEffect } from 'react';
import TablaUTE from './tablauteporcentaje';

export const PorcentajeUTE = (props) => {

    return (
        <div className='container-fluid rounded p-0 m-0'>
           <div className='container-fluid w-100 h-100 p-0 m-0'>
               <TablaUTE/>
           </div>
        </div>

    );
}


// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/valoruteporcentaje.js